import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const RankItemWrapper = ({ children, id }, ref) => {
    return (_jsx("div", { id: id, ref: ref, className: cx('rank-item'), children: children }, id));
};
export default forwardRef(RankItemWrapper);
//# sourceMappingURL=rankItemWrapper.js.map